// Components/NewUsers.js
import React from 'react';
import { AiOutlineUser } from 'react-icons/ai';

const NewUsers = ({ users }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
        <AiOutlineUser /> New Users
      </h3>
      <table className="w-full text-left border-collapse">
        <thead>
          <tr className="bg-gray-200 text-gray-700">
            <th className="py-2 px-4">Name</th>
            <th className="py-2 px-4">Email</th>
            <th className="py-2 px-4">Joined</th>
            <th className="py-2 px-4">Plan</th>
            <th className="py-2 px-4">Last Login</th>
            <th className="py-2 px-4">Payment Method</th>
            <th className="py-2 px-4">Subscription</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={index} className="border-b">
              <td className="py-2 px-4">{user.name}</td>
              <td className="py-2 px-4">{user.email}</td>
              <td className="py-2 px-4">{user.joinedDate}</td>
              <td className="py-2 px-4">{user.plan}</td>
              <td className="py-2 px-4">{user.lastLogin}</td>
              <td className="py-2 px-4">{user.paymentMethod}</td>
              <td className="py-2 px-4">
                <span className={`px-2 py-1 rounded-full text-white ${user.subscriptionStatus === 'Active' ? 'bg-green-500' : 'bg-red-500'}`}>
                  {user.subscriptionStatus}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default NewUsers;
